export default "__VITE_ASSET__CC2KSsOw__"